
import { PropType, computed, defineComponent } from 'vue'
import { iconBigeye, iconSmall, iconCockroach } from '@/components/icons'
import { useI18n } from 'vue-i18n'
import { RoadMapSummaryData } from '../roadmap/datamodel/types'
import { RoadMapData } from '../roadmap/datamodel/RoadMapData'

export default defineComponent({
    components: {
        iconBigeye,
        iconCockroach,
        iconSmall
    },
    props: {
        color: {
            type: String as PropType<'blue' | 'red'>,
            default: () => 'blue'
        },
        gameType: {
            required: true,
            type: Number as PropType<number>
        },
        mapdata: {
            required: true,
            type: Object as PropType<RoadMapSummaryData>
        }
    },
    setup(props) {
        const { t } = useI18n()

        const preLabel = computed(() => {
            let _label = ''
            if (props.color === 'red' && props.gameType === 1) {
                _label = `${t('roadmap.banker')}${t('roadmap.ask')}`
            } else if (props.color === 'red' && props.gameType === 2) {
                _label = `${t('roadmap.dragon')}${t('roadmap.ask')}`
            } else if (props.color === 'blue' && props.gameType === 1) {
                _label = `${t('roadmap.player')}${t('roadmap.ask')}`
            } else if (props.color === 'blue' && props.gameType === 2) {
                _label = `${t('roadmap.tiger')}${t('roadmap.ask')}`
            }

            return _label
        })

        const hasNoData = computed(() => {
            if (!props.mapdata.data) return true

            const mapData = props.mapdata.data as RoadMapData

            return mapData.bigeyes.length <= 0
        })

        const hasSmall = computed(() => {
            if (!props.mapdata.data) return true

            const mapData = props.mapdata.data as RoadMapData

            return mapData.smalls.length <= 0
        })

        const hasCockroach = computed(() => {
            if (!props.mapdata.data) return true

            const mapData = props.mapdata.data as RoadMapData

            return mapData.cockroachs.length <= 0
        })

        const bigeyeColor = computed((): number => {
            if (!props.mapdata.data) return 0
            const mapData = props.mapdata.data as RoadMapData

            if (mapData.bigeyes.length <= 0) return 0

            return mapData.bigeyes[mapData.bigeyes.length - 1].type
        })

        const smallColor = computed((): number => {
            if (!props.mapdata.data) return 0
            const mapData = props.mapdata.data as RoadMapData

            if (mapData.smalls.length <= 0) return 0

            return mapData.smalls[mapData.smalls.length - 1].type
        })

        const cocroachColor = computed((): number => {
            if (!props.mapdata.data) return 0
            const mapData = props.mapdata.data as RoadMapData

            if (mapData.cockroachs.length <= 0) return 0

            return mapData.cockroachs[mapData.cockroachs.length - 1].type
        })

        return {
            preLabel,
            cocroachColor,
            smallColor,
            hasCockroach,
            hasNoData,
            hasSmall,
            bigeyeColor
        }
    }
})
